import * as React from 'react';

// ICONS
import { ReactComponent as MainLogo } from '../../assets/img/logo-main.svg';

// COMPONENTS
import ForgotForm from './ForgotForm';

interface ForgotPasswordTypes {}

export const ForgotPassword: React.FC<ForgotPasswordTypes> = ({}) => {
	return (
		<div className="page-forgot-password">
			<div className="standalone-panel">
				<div className="panel panel-forgot">
					<div className="header">
						<h1 className="h2">Forgot your password?</h1>

						<p className="sub-grey-text">
							Enter your details below to receive an email with a link to reset your password
						</p>
					</div>
					<ForgotForm />
				</div>
			</div>
		</div>
	);
};

export default ForgotPassword;
